import '../sass/employee-handbook-menu-group.scss';

(() => {
    const $employeeHandbookMenuGroups = document.querySelectorAll('.employee-handbook-menu-group');
    const $employeeHandbookNextGroup = document.querySelector('.employee-handbook-next-group');
    const $employeeHandbookNextGroupLink = document.querySelector('.employee-handbook-next-group a');

    if (!$employeeHandbookMenuGroups) return;

    const employeeHandbookMenuGroupActive = () => {
        $employeeHandbookMenuGroups.forEach(($employeeHandbookMenuGroup, i) => {
            if ($employeeHandbookMenuGroup.getBoundingClientRect().top <= (window.innerHeight / 2) && 
                $employeeHandbookMenuGroup.getBoundingClientRect().top + $employeeHandbookMenuGroup.scrollHeight > (window.innerHeight / 2)) {

                document.querySelector('.employee-handbook-menu__menu-group-link--active')?.classList?.remove('employee-handbook-menu__menu-group-link--active');
                document.querySelector(`.employee-handbook-menu__menu-group-link--${$employeeHandbookMenuGroup?.id}`)?.classList?.add('employee-handbook-menu__menu-group-link--active');

                if ($employeeHandbookNextGroupLink) {
                    const $nextEmployeeHandbookMenuGroup = $employeeHandbookMenuGroups[i + 1];

                    if ($nextEmployeeHandbookMenuGroup) {
                        $employeeHandbookNextGroup.classList.remove('employee-handbook-next-group--hide');
                        $employeeHandbookNextGroupLink.href = `#${$nextEmployeeHandbookMenuGroup?.id}`;
                    } else {
                        $employeeHandbookNextGroup.classList.add('employee-handbook-next-group--hide');
                    }
                }
            }
        });
    };

    window.addEventListener('scroll', employeeHandbookMenuGroupActive);

    employeeHandbookMenuGroupActive();
})();
